<div class="flex-left-column light-control-host">
  <div class="flex-center-row">
    <h3 class="panel-title">Conclude test for "{{ !!application ? application.name : '' }}"</h3>
  </div>
  <div class="error margin-top">
    Note: Concluding a test for an application will dispose of resources in the recovery region, returning the
    application to an idle state. Do not perform this action until you no longer need these resources.
  </div>
  <div class="margin-top">Select applications to turn down in {{ !!application ? application.targetRegion : '' }}</div>
  <!-- Select All Checkbox -->
  <div class="select-all-container resource-type flex-center-row margin-top" *ngIf="applications.length > 0">
    <input
      type="checkbox"
      class="arpio-checkbox"
      [checked]="areAllApplicationsSelected()"
      (change)="toggleSelectAllApplications($event.target.checked)"
      [disabled]="applications.length === 0"
    />
    <div class="select-all-label" (click)="toggleSelectAllApplications(!areAllApplicationsSelected())">
      {{ areAllApplicationsSelected() ? 'Deselect All' : 'Select All' }}
    </div>
  </div>
  <div class="flex-center-row full-width margin-top">
    <div id="applicationSelectionList" class="light-content-panel spacer">
      <div class="flex-center-row" *ngFor="let application of applications; trackBy: applicationTrackBy">
        <input
          id="app-id"
          class="arpio-checkbox"
          type="checkbox"
          (input)="toggleApplicationSelection(application.applicationObj.applicationId)"
          [checked]="applicationIsChecked(application.applicationObj)"
        />
        <div class="application-name margin-left">{{ application.applicationObj.name }}</div>
      </div>
    </div>
  </div>
  <div class="flex-center-row margin-top full-width">
    <div>Was this test successful?</div>
    <div class="select-wrapper flex-center-row spacer">
      <select class="arpio-select margin-left spacer" [(ngModel)]="successfulTest">
        <option value=""></option>
        <option value="true">Yes</option>
        <option value="false">No</option>
      </select>
    </div>
  </div>
  <textarea class="margin-top" placeholder="Notes" [(ngModel)]="testNotes" rows="=3"></textarea>
  <ng-container *ngIf="protectRecoveryPointEnabled">
    <div class="flex-center-row margin-top">
      <input id="protect-rps" class="arpio-checkbox" type="checkbox" [(ngModel)]="protectRecoveryPoints" />
      <label for="protect-rps">
        <h4 class="half-margin-left">Retain Recovery Points Indefinitely</h4>
      </label>
    </div>
    <div>
      Normally, Recovery Points are deleted based on your retention policy. Checking this box ensures they are retained
      until manually removed. You can manage your retained Recovery Points on the
      <a href="{{ retentionPolicyUrl }}" target="_blank">Retention Policy</a> screen.
    </div>
  </ng-container>
  <div class="flex-center-row margin-top full-width">
    <div class="spacer"></div>
    <button class="arpio-secondary-button" (click)="onCancelClick()">CANCEL</button>
    <button
      busy-button
      [busy]="launching"
      id="conclude-button"
      class="arpio-button margin-left"
      (click)="onConcludeClick()"
      [disabled]="(successfulTest != 'true' && successfulTest != 'false') || launching"
    >
      CONCLUDE TEST
    </button>
    <div class="spacer"></div>
  </div>
</div>
